export default {
  title: 'תעריפון',
  box: {
    full: {
      title: 'ניתוח תיק מלא',
      content: 'הוצאת נתונים מהר הביטוח, מהמסלקה וניתוח עומק של המידע, בדיקת עלויות, דמי ניהול, מסלולי השקעה, אלטרנטיבות לניהול כסף פנוי, צוואות וירושות,נדל"ן, הגדרת מטרות פיננסיות ובניית תקציב לניהול סיכונים.',
      price: '₪5,000',
    },
    risk: {
      title: 'ניתוח תיק סיכונים ובריאות',
      content: 'בדיקת עלויות מול אלטרנטיבה, בדיקת כפילויות והצגה ללקוח הוצאת נתונים מהר הביטוח, שליחת יפוי כח לחברות, התאמה לחיובים בבנק.',
      price: '₪3,000',
    },
    retire: {
      title: 'תכנון פרישה',
      content: 'בחינת חלופות בעת יציאה לפרישה תוך מזעור חבות המס, הפרדת גמל ופיצויים לפי ייעוד להון וקצבה, בדיקת טפסי 161. ליווי לקוח מול רשויות המס בעת הצורך.',
      price: '₪4,500 - ₪10,000',
    },
    escort: {
      title: 'ליווי מתמשך בעלות קבועה',
      content: 'זמינות וטיפול אישי, ביצוע כל הפעולות ללא עלות נוספת פגישת שירות שנתית,עדכון והתאמה של התיק הביטוחי/פנסיוני.',
      price: '₪500 - ₪1,000 לת״ז לחודש',
    },
    once: {
      title: 'פגישת שירות חד פעמית / תקופתית למי שאינו לקוח הסוכנות',
      content: 'פגישה אישית לבקשת הלקוח שאינו לקוח הסוכנות.',
      price: '₪380 לשעה',
    },
    home: {
      title: 'שעת פגישה ראשונה בבית הלקוח',
      content: 'הכרות, תיאום ציפיות וקבלת החלטה על אסטרטגיית ליווי גדרה -חדרה (מעבר לגבולות).',
      price: '₪700 - ₪1,000',
    },
    office: {
      title: 'שעת פגישה ראשונה במשרד',
      content: 'הכרות, תיאום ציפיות וקבלת החלטה על אסטרטגיית ליווי.',
      price: '₪500',
    },
    year: {
      title: 'פגישת שירות שנתית',
      content: 'הכנת דוח כיסויים מרוכז על תיק הלקוח בסוכנות.',
      price: '₪500',
    },
    subscription: {
      title: 'מינוי סוכן על פוליסות קיימות ללקוח חדש',
      content: 'קבלת פוליסה קיימת לטיפול שוטף.',
      price: '₪350 - ₪550',
    },
    external: {
      title: 'טיפול בתביעה בפוליסה חיצונית',
      content: 'טיפול, הכוונה וסיוע בהגשת תביעה למיצוי זכויות פנסיה, נכות, שאירים, סיעוד, בריאות, אכע, תאונות אישיות ועוד (בתשלום לשיעורין עד 36 תשלומים)',
      price: '20% על פי הצלחה',
    },
  },
};
